var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge-container",class:_vm.classes},[_c('v-badge',{staticClass:"custom-badge",attrs:{"color":_vm.getStatusColor,"dot":""}}),_c('span',{staticClass:"status-label"},[_vm._v(_vm._s(_vm.computedStatus))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }